export function setAllStateValuesToFalse<T>(state: T): T {
  return Object.keys(state).reduce((acc: any, key: string) => {
    acc[key] = false;
    return acc;
  }, state);
}
